import React, { Component } from "react";

import TextField from "./form/TextField";
import TextareaField from "./form/TextareaField";
import CheckboxField from "./form/CheckboxField";
import moment from "moment";
import db from "../../api/db";
import DatePicker, { registerLocale } from "react-datepicker";
import nb from "date-fns/locale/nb";
import SelectField from "./form/SelectField";
import CircularProgress from "@material-ui/core/CircularProgress";

const countryList = require("country-list");

registerLocale("nb", nb);

class PersonEditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      array: {
        firstname: "",
        lastname: "",
        code: 1,
        country: 0,
        birthdate: null,
        deceasedDate: null,
        achievements: {
          nb: "",
          de: "",
          en: ""
        },
        bio: {
          nb: "",
          de: "",
          en: ""
        },
        tags: {
          nb: "",
          de: "",
          en: ""
        }
      },
      male: false,
      female: false,
      loading: true,
      disabled: false,
      status: false,
      id: this.props.person,
      new: false,
      images: [],
      image_button: "Last opp bilde",
      achievements_nb: "",
      tags_nb: "",
      bio_nb: "",
      change_glory: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handledateChange = this.handledateChange.bind(this);
    this.handleDeathdateChange = this.handleDeathdateChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleMultilingualChange = this.handleMultilingualChange.bind(this);
    this.getSingledoc = this.getSingledoc.bind(this);
  }

  defaultState() {
    return {
      array: {
        firstname: "",
        lastname: "",
        code: 1,
        country: 0,
        birthdate: null,
        deceasedDate: null,
        achievements: {
          nb: "",
          de: "",
          en: ""
        },
        bio: {
          nb: "",
          de: "",
          en: ""
        },
        tags: {
          nb: "",
          de: "",
          en: ""
        }
      },
      id: "",
      loading: false,
      new: true,
      status: false,
      male: false,
      female: false,
      images: [],
      image_button: "Last opp bilde",
      achievements_nb: "",
      bio_nb: "",
      tags_nb: ""
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.state.id && this.state.id !== "new") {
      this.getSingledoc();
    } else if (this.state.id === "new") {
      const defaultState = this.defaultState();
      this.setState(defaultState);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillReceiveProps(props) {
    if (props.person === "new") {
      const defaultState = this.defaultState();
      this.setState(defaultState);
    } else if (
      props.person !== this.state.array.id ||
      props.person !== this.state.id
    ) {
      this.setState({
        loading: true
      });
      this.getSingledoc(props.person);
    }
  }

  getSingledoc(id = this.state.id) {
    db.get("person", id).then(response => {
      let male = false;
      let female = false;
      let status = false;
      if (response.data.gender === "Male") {
        male = true;
      } else if (response.data.gender === "Female") {
        female = true;
      }

      if (response.data.code !== 1) {
        status = true;
      }

      const person = response.data;

      if (this._isMounted) {
        this.setState({
          array: person,
          id: id,
          new: false,
          male: male,
          female: female,
          status: status,
          loading: false,
          images: response.data.images ? response.data.images : [],
          achievements_nb: person.achievements ? person.achievements.nb : "",
          bio_nb: person.bio ? person.bio.nb : "",
          tags_nb: person.tags ? person.tags.nb : ""
        });
      }
    });
  }

  handleChange(event, arrays) {
    let person = this.state.array;
    let male = this.state.male;
    let female = this.state.female;
    let status = this.state.status;
    const name = event.target.name;

    if (!arrays) {
      if (event.target.type === "checkbox") {
        if (name === "Male" || name === "Female") {
          person["gender"] = name;
          if (name === "Male") {
            male = true;
            female = false;
          } else {
            female = true;
            male = false;
          }
        } else if (name === "status") {
          status = event.target.checked;
          if (status) {
            person["code"] = 5;
          } else {
            person["code"] = 1;
          }
        } else {
          person[name] = event.target.checked;
        }
      } else {
        person[name] = event.target.value;
      }
    }
    if (name === "glory") {
      this.setState({
        change_glory: true
      });
    }

    person["fullname"] = `${person.firstname} ${person.lastname}`;

    this.setState({
      array: person,
      male: male,
      female: female,
      status: status
    });
  }

  handleMultilingualChange(event) {
    let person = this.state.array;
    const name = event.target.name;
    let achievements_nb = this.state.achievements_nb;
    let tags_nb = this.state.tags_nb;
    let bio_nb = this.state.bio_nb;

    if (name === "achievements_nb") {
      person.achievements.nb = achievements_nb = event.target.value;
    } else if (name === "tags_nb") {
      person.tags.nb = tags_nb = event.target.value;
    } else if (name === "bio_nb") {
      person.bio.nb = bio_nb = event.target.value;
    }

    this.setState({
      array: person,
      achievements_nb: achievements_nb,
      bio_nb: bio_nb,
      tags_nb: tags_nb
    });
  }

  handledateChange(date) {
    let person = this.state.array;

    person["birthdate"] = moment(date).format("YYYY-MM-DD");
    person["day"] = moment(date).format("DD");
    person["month"] = moment(date).format("MM");
    person["year"] = moment(date).format("YYYY");

    this.setState({
      array: person
    });
  }

  handleDeathdateChange(date) {
    let person = this.state.array;
    person["deceasedDate"] = moment(date).format("YYYY-MM-DD");
    this.setState({
      array: person
    });
  }

  handleCountryChange(event) {
    const target = event.target;
    const value = target.value;

    let person = this.state.array;
    person["country"] = value;

    this.setState({
      array: person
    });
  }

  formatCountrySelect() {
    const countries = countryList.getData();
    const selectlist = [];
    for (var i = countries.length - 1; i >= 0; i--) {
      selectlist.push({
        value: countries[i].code,
        label: countries[i].name
      });
    }

    return selectlist.reverse();
  }

  handleSubmit(event) {
    event.preventDefault();
    const person = this.state.array;
    person._change = {
      glory: this.state.change_glory
    };

    if (!this.state.new && this.state.id) {
      this.setState({
        disabled: true
      });

      db.patch("person", this.preProcessExport(person))
        .then(response => {
          const upperson = this.postProcessImport(response.data);
          this.setState({
            array: upperson,
            disabled: false,
            achievements_nb: upperson.achievements
              ? upperson.achievements.nb
              : "",
            bio_nb: upperson.bio ? upperson.bio.nb : "",
            tags_nb: upperson.tags ? upperson.tags.nb : ""
          });
        })
        .catch(err => {
          console.log(err);
        });
    } else if (this.state.new) {
      this.setState({
        loading: true
      });

      db.create("person", this.preProcessExport(person))
        .then(response => {
          this.setState(
            {
              loading: false,
              array: this.postProcessImport(person),
              new: false,
              id: response.data.id
            },
            () => {
              this.props.setPerson(response.data.id);
            }
          );
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  submittable() {
    let submittable = true;
    const person = this.state.array;

    if (!this.state.male && !this.state.female) {
      submittable = false;
    }

    if (
      !person.birthdate ||
      !person.country ||
      !person.firstname ||
      !person.lastname ||
      !person.city
    ) {
      submittable = false;
    }

    return submittable;
  }

  handleAbort(event) {
    this.props.clear();
    this.setState({
      id: ""
    });
  }

  postProcessImport(person) {
    if (
      typeof person.achievements !== "object" ||
      Object.prototype.toString.call(person.achievements) === "[object Array]"
    ) {
      person.achievements = { nb: "", de: "", en: "" };
    }

    return person;
  }

  preProcessExport(person) {
    Object.assign(person, {
      id: this.state.id,
      fleng: true,
      update_local: moment().format()
    });

    return person;
  }

  render() {
    const person = this.state.array;
    const birthdate = person.birthdate
      ? moment(person.birthdate).toDate()
      : null;
    const deceasedDate = person.deceasedDate
      ? moment(person.deceasedDate).toDate()
      : null;

    if (!this.state.id && !this.state.new) {
      return null;
    }

    if (this.state.loading) {
      return (
        <div className="client-card-form-holder">
          <CircularProgress size={20} />
        </div>
      );
    }

    let metadata;

    if (this.state.id !== "new" && person.update_local) {
      metadata = (
        <div className="cell shrink metadata">
          Oppdatert: {moment(person.update_local).format("DD.MM YYYY, HH:mm")}
          <br />
          {this.state.id}
        </div>
      );
    }

    return (
      <div className="client-card-form-holder">
        <form className="client-card-form" onSubmit={this.handleSubmit}>
          <div className="grid-x">
            <div className="cell auto heading">
              {person.alias
                ? `${person.alias} (${person.fullname})`
                : person.fullname}
            </div>
            {metadata}
          </div>
          <fieldset disabled={this.state.disabled}>
            <div className="grid-x">
              <div className="medium-10 cell col-1">
                <div className="grid-x">
                  <div className="medium-6 cell c1">
                    <TextField
                      className="white-input"
                      name="firstname"
                      value={person.firstname}
                      label="Fornavn"
                      onChange={this.handleChange}
                      required={true}
                    />
                  </div>
                  <div className="medium-6 cell">
                    <TextField
                      className="white-input"
                      name="lastname"
                      value={person.lastname}
                      label="Etternavn"
                      onChange={this.handleChange}
                      required={true}
                    />
                  </div>
                  <div className="medium-6 cell c1">
                    <TextField
                      className="white-input"
                      name="city"
                      value={person.city}
                      label="By"
                      onChange={this.handleChange}
                      required={true}
                    />
                  </div>
                  <div className="medium-6 cell">
                    <SelectField
                      name="country"
                      value={person.country}
                      className={["white-input"]}
                      label="Land"
                      required={true}
                      onChange={this.handleCountryChange}
                      options={this.formatCountrySelect()}
                    />
                  </div>
                  <div className="medium-6 cell c1">
                    <div className="white-datepicker">
                      <label>Fødselsdato</label>
                      <DatePicker
                        selected={birthdate}
                        onChange={this.handledateChange}
                        onSelect={this.handledateChange}
                        locale="nb"
                        dateFormat="dd.MMMM yyyy"
                        placeholderText="Velg dato"
                        showYearDropdown
                        yearDropdownItemNumber={110}
                        scrollableYearDropdown
                      />
                    </div>
                  </div>
                  <div className="medium-6 cell">
                    <TextField
                      className="white-input"
                      name="alias"
                      value={person.alias}
                      label="Kallenavn / Alias"
                      onChange={this.handleChange}
                    />
                  </div>
                  {this.state.status ? (
                    <div className="medium-6 cell c1">
                      <div className="white-datepicker">
                        <label>Dødsdato</label>
                        <DatePicker
                          selected={deceasedDate}
                          onChange={this.handleDeathdateChange}
                          onSelect={this.handleDeathdateChange}
                          locale="nb"
                          dateFormat="dd.MMMM yyyy"
                          placeholderText="Velg dato"
                          showYearDropdown
                          yearDropdownItemNumber={110}
                          scrollableYearDropdown
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="medium-2 cell col-2">
                <CheckboxField
                  name="status"
                  value={this.state.status}
                  label="Død"
                  onChange={this.handleChange}
                />
                <div className="subheading">Kjønn</div>
                <CheckboxField
                  name="Male"
                  value={this.state.male}
                  label="Mann"
                  onChange={this.handleChange}
                />
                <CheckboxField
                  name="Female"
                  value={this.state.female}
                  label="Kvinne"
                  onChange={this.handleChange}
                />
                <div className="subheading">Kategorier</div>
                <CheckboxField
                  name="famous"
                  value={person.famous}
                  label="Kjent"
                  onChange={this.handleChange}
                />
                <CheckboxField
                  name="sport"
                  value={person.sport}
                  label="Idrettsprofil"
                  onChange={this.handleChange}
                />
                <CheckboxField
                  name="glory"
                  value={person.glory}
                  label="Æresgalleri"
                  onChange={this.handleChange}
                />
                <CheckboxField
                  name="fleng"
                  value={true}
                  label="Utenlandsk"
                  onChange={this.handleChange}
                  disabled={true}
                />
              </div>
            </div>
            <div className="section alt-bg">
              <div className="subheading">Beskrivelse</div>
              <TextField
                className="white-input"
                name="title"
                label="Tittel"
                value={person.title}
                onChange={this.handleChange}
              />
              <TextareaField
                className="white-input"
                name="comment"
                value={person.comment}
                label="Kommentarer"
                onChange={this.handleChange}
              />
              {person.glory ? (
                <React.Fragment>
                  <TextareaField
                    className="white-input"
                    name="bio_nb"
                    value={this.state.bio_nb}
                    label="Biografi Æresgalleri"
                    onChange={this.handleMultilingualChange}
                  />
                  <TextareaField
                    className="white-input"
                    name="achievements_nb"
                    value={this.state.achievements_nb}
                    label="Utmerkelser"
                    onChange={this.handleMultilingualChange}
                  />
                  <TextField
                    className="white-input"
                    name="tags_nb"
                    label="Tags (ord separert med komma)"
                    value={
                      typeof this.state.tags_nb === "string"
                        ? this.state.tags_nb
                        : ""
                    }
                    onChange={this.handleMultilingualChange}
                  />
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
            {this.state.id && this.state.id !== "new" ? (
              <div className="medium-12 cell grid-x"></div>
            ) : (
              ""
            )}
            <div className="medium-12 cell"></div>
            <div className="footer section alt-bg">
              <input
                className="button"
                type="submit"
                disabled={!this.submittable() || this.state.disabled}
                value={this.state.disabled ? "Lagrer..." : "Lagre"}
              />
              <input
                className="button link"
                onClick={e => this.handleAbort()}
                type="button"
                value="Avbryt"
              />
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default PersonEditCard;
